import { theme, darkTheme } from './theme/themeVariables';

const config = {
  darkMode: localStorage.getItem('darkMode') ?? false,
  topMenu: false,
  rtl: false,
  theme,
  darkTheme,
  auth0: true,
};

export default config;
